import { render } from "./BuildingInfo.vue?vue&type=template&id=9597652a"
import script from "@/assets/js/BuildingInfo.js?vue&type=script&lang=js"
export * from "@/assets/js/BuildingInfo.js?vue&type=script&lang=js"

import exportComponent from "/tmp/workdir/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__